// extracted by css-extract-rspack-plugin
export default {"MenuBtn":"OrganisationCardActions_MenuBtn__hOEuG"};